import React from 'react';

import AirIcon from '../../../../../common/icons/AirIcon';

export default translationsStore => ({
    width: '72px',
    align: 'center',
    title: (
        <span>
      <div>{translationsStore.translate('lead.table.column.mainDay.days')}</div>
      <div>{translationsStore.translate('lead.table.column.mainDay.main')}</div>
    </span>
    ),
    dataIndex: 'daysToFutureM',
    sorter: (a, b) => a.daysToFutureM - b.daysToFutureM,
    render: (text, record) => {
        return (
            Number.isInteger(text) && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                    <AirIcon type="tagliando" style={{ color: record.daysToFutureMRed ? 'red' : record.daysToFutureMOrange ? 'orange' : 'green' }} />
                    {Number.isInteger(text) && text}
                </div>
            )
        );
    }
});
